export var EventStatus;
(function (EventStatus) {
    EventStatus["New"] = "NEW";
    EventStatus["Assigned"] = "ASSIGNED";
    EventStatus["InProgress"] = "IN_PROGRESS";
    EventStatus["WaitingForResponse"] = "WAITING_FOR_RESPONSE";
    EventStatus["FalsePositive"] = "FALSE_POSITIVE";
    EventStatus["Resolved"] = "RESOLVED";
})(EventStatus || (EventStatus = {}));
export var EventHistoryField;
(function (EventHistoryField) {
    EventHistoryField["ASSIGNEE"] = "ASSIGNEE";
    EventHistoryField["STATUS"] = "STATUS";
    EventHistoryField["COMMENT"] = "COMMENT";
})(EventHistoryField || (EventHistoryField = {}));
export var EventManagementTestSubjects;
(function (EventManagementTestSubjects) {
    EventManagementTestSubjects["UpdateEvent"] = "update-event";
    EventManagementTestSubjects["EventsManagementPage"] = "em-events-management-page";
    EventManagementTestSubjects["FilterTimeframe"] = "em-filter-timeframe";
    EventManagementTestSubjects["FilterAssignee"] = "em-filter-assignee";
    EventManagementTestSubjects["FilterSeverity"] = "em-filter-severity";
    EventManagementTestSubjects["FilterStatus"] = "em-filter-status";
    EventManagementTestSubjects["ClearFilter"] = "em-clear-filter";
    EventManagementTestSubjects["EventsTable"] = "em-events-table";
    EventManagementTestSubjects["EventRecordGroup"] = "em-group-event";
    EventManagementTestSubjects["EventRecordId"] = "em-event-record-id";
    EventManagementTestSubjects["EventRecordName"] = "em-event-record-name";
    EventManagementTestSubjects["EventRecordCount"] = "em-event-record-count";
    EventManagementTestSubjects["EventRecordDescription"] = "em-event-record-description";
    EventManagementTestSubjects["EventRecordStatus"] = "em-event-record-status";
    EventManagementTestSubjects["EventRecordAssignee"] = "em-event-record-assignee";
    EventManagementTestSubjects["EventRecordUpdatedAt"] = "em-event-record-updated-at";
    EventManagementTestSubjects["EventRecordUpdatedBy"] = "em-event-record-updated-by";
    EventManagementTestSubjects["EventRecordComment"] = "em-event-record-comment";
    EventManagementTestSubjects["EventRecordCommentedBy"] = "em-event-record-commented-by";
    EventManagementTestSubjects["EventRecordInvestigateButton"] = "em-event-record-investigate";
    EventManagementTestSubjects["EventRecordEditButton"] = "edit";
    EventManagementTestSubjects["EventDetailsModal"] = "em-event-details-modal";
    EventManagementTestSubjects["EventDetailsDrawer"] = "em-event-details-drawer";
    EventManagementTestSubjects["DrawerCloseButton"] = "em-event-details-drawer-close-button";
    EventManagementTestSubjects["SubEvent"] = "em-sub-event";
    EventManagementTestSubjects["EventRecordTitle"] = "em-record-title";
    EventManagementTestSubjects["EventDetailsGroupId"] = "em-event-details-group-id";
    EventManagementTestSubjects["EventDetailsDescription"] = "em-event-details-description";
    EventManagementTestSubjects["EventDetailsRecordTriggeredAt"] = "em-event-details-triggered-at";
    EventManagementTestSubjects["EventDetailsRecordId"] = "em-event-details-id";
    EventManagementTestSubjects["EventDetailsGroupingType"] = "em-event-details-grouping-type";
    EventManagementTestSubjects["EventDetailsRecordLink"] = "em-event-details-link";
    EventManagementTestSubjects["EventHistoryModal"] = "em-history-modal";
    EventManagementTestSubjects["EventHistoryId"] = "em-event-history-id";
    EventManagementTestSubjects["EventHistoryDescription"] = "em-event-history-description";
    EventManagementTestSubjects["EventHistoryRecordCreatedAt"] = "em-event-history-record-created-at";
    EventManagementTestSubjects["EventHistoryRecordCell"] = "em-event-history-record-cell";
    EventManagementTestSubjects["HistoryRecordChangedAssigneeBy"] = "em-history-record-changed-assignee-by";
    EventManagementTestSubjects["HistoryRecordNewAssignee"] = "em-history-record-new-assignee";
    EventManagementTestSubjects["HistoryRecordCommentedBy"] = "em-history-record-commented-by";
    EventManagementTestSubjects["HistoryRecordNewComment"] = "em-history-record-new-comment";
    EventManagementTestSubjects["HistoryRecordStatusChangedBy"] = "em-history-record-status-changed-by";
    EventManagementTestSubjects["HistoryRecordStatusFrom"] = "em-history-record-status-from";
    EventManagementTestSubjects["HistoryRecordStatusTo"] = "em-history-record-status-to";
})(EventManagementTestSubjects || (EventManagementTestSubjects = {}));
export var SiemEventType;
(function (SiemEventType) {
    SiemEventType["Group"] = "GROUP";
    SiemEventType["AlertEvent"] = "ALERT_EVENT";
})(SiemEventType || (SiemEventType = {}));
/** Where a SIEM event came from. Rule events omit the field in the API, so absent means Rule. */
export var SiemEventSource;
(function (SiemEventSource) {
    SiemEventSource["Rule"] = "RULE";
    SiemEventSource["Agent"] = "AGENT";
})(SiemEventSource || (SiemEventSource = {}));
export var EventModelGroupingType;
(function (EventModelGroupingType) {
    EventModelGroupingType["AlertBased"] = "ALERT_BASED";
    EventModelGroupingType["IpBased"] = "IP_BASED";
})(EventModelGroupingType || (EventModelGroupingType = {}));
export const eventManagementRCAPrompt = 'Help me investigate the root cause of a this security event.';
export var LogEventsSubjects;
(function (LogEventsSubjects) {
    LogEventsSubjects["Count"] = "log-events-count";
    LogEventsSubjects["Notice"] = "log-events-notice";
    LogEventsSubjects["BulkUpdateButton"] = "log-events-bulk-update-button";
    LogEventsSubjects["BulkUpdateModal"] = "log-events-bulk-update-modal";
    LogEventsSubjects["RowActionsMenu"] = "log-events-row-actions-menu";
    LogEventsSubjects["RowActionsTrigger"] = "log-events-row-actions-trigger";
    LogEventsSubjects["RowActionViewDetails"] = "log-events-row-action-view-details";
    LogEventsSubjects["RowActionInvestigate"] = "log-events-row-action-investigate";
    LogEventsSubjects["RowActionViewHistory"] = "log-events-row-action-view-history";
    LogEventsSubjects["RowActionEditEvent"] = "log-events-row-action-edit-event";
    LogEventsSubjects["RowActionEditAlert"] = "log-events-row-action-edit-alert";
})(LogEventsSubjects || (LogEventsSubjects = {}));
//# sourceMappingURL=manage-events.enum.js.map